/**
 * Code Analysis - 진단(에러/경고) API
 */
import { langServerClient } from '@/shared/api/langserver/client';

import type { ModuleTarget } from '@/entities/langserver/api/types';

import type { AnalysisRequest, Diagnostic } from './types';

export const fetchDiagnostics = async (
  target: ModuleTarget = 'run',
  payload: AnalysisRequest
): Promise<Diagnostic[]> => {
  try {
    const response = await langServerClient.post<Diagnostic[]>(
      `/${target}/api/v1/analysis/template/diagnostics`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch diagnostics:', error);
    return [];
  }
};
